// Tiny wrapper around localStorage or sessionStorage, to automatically serialize as json, and optional expiration
//
// If the browser does not support localStorage or sessionStorage, writes are ignored and reads always return undefined.
export class LocalSessionStore {
  // Initialize an instance of LocalSessionStore.
  //
  // +type+ may be either "local" for localStorage or "session" for sessionStorage
  constructor(type = "local") {
    this.store = null;
    switch (type) {
      case "local":
        if ("localStorage" in window) {
          this.store = window.localStorage;
        }
        break;
      case "session":
        if ("sessionStorage" in window) {
          this.store = window.sessionStorage;
        }
        break;
      default:
        throw "Unknown storage type";
    }
  }

  // Set +key+ to +value+, with optional expiration time in +expires_in+ seconds
  set(key, value, expires_in = 0) {
    if (!this.store) {
      return undefined;
    }

    const data = {
      expires_at: new Date().getTime() + expires_in * 1000,
      value,
    };

    return this.store.setItem(key, JSON.stringify(data));
  }

  // Retrieve +key+
  get(key) {
    if (!this.store) {
      return undefined;
    }

    let data = this.store.getItem(key);
    if (!data) {
      return undefined;
    }

    data = JSON.parse(data);

    if (data.expires_at < new Date().getTime()) {
      this.store.removeItem(key);
      return undefined;
    }

    return data.value;
  }

  // Remove +key+
  remove(key) {
    if (!this.store) {
      return undefined;
    }
    return this.store.removeItem(key);
  }
}
